'use client';

import { clsx } from 'clsx';
import React, { FC } from 'react';
import { CategoryChipStoryblok, CategoryChipsStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Icon, IconType } from 'atoms/Icon';
import { Link } from 'atoms/Link/Link';
import { gtmPushFilter } from 'modules/gtm/modules/sections/productList/filters';
import styles from './category-chips.module.css';

export const CategoryChips: FC<{ blok?: CategoryChipsStoryblok }> = ({
  blok,
}) => {
  return !blok ? null : (
    <div className={styles.root}>
      {blok.chips?.map(({ link, _uid, title, icon }: CategoryChipStoryblok) => (
        <Link
          className={styles.link}
          href={link.story.url || ''}
          key={_uid}
          onClick={() =>
            gtmPushFilter({
              event_name: 'filter_sexual_orientation',
              event_action: 'sexual orientation',
              value: title,
            })
          }
        >
          <Button
            size="large"
            className={clsx(
              styles.item,
              title === blok.selectedOption && styles.active,
            )}
            aria-label={title}
          >
            <Icon className={styles.icon} type={IconType[icon]} />
            {title}
          </Button>
        </Link>
      ))}
    </div>
  );
};
